// extracted by mini-css-extract-plugin
export default {"PFSServicePoints":"PFSServicePoints_PFSServicePoints__CTQW-","unOrderedList":"PFSServicePoints_unOrderedList__M65Q2","PointsHeader":"PFSServicePoints_PointsHeader__0vGl3"};